import { render } from "./PersonalisationFinishPage.vue?vue&type=template&id=1c0310ce&scoped=true"
import script from "./PersonalisationFinishPage.vue?vue&type=script&lang=js"
export * from "./PersonalisationFinishPage.vue?vue&type=script&lang=js"

import "./PersonalisationFinishPage.vue?vue&type=style&index=0&id=1c0310ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0310ce"]])

export default __exports__